import React, { useState } from "react";
import Navbar from "@/components/landing/Navbar";
import AnnouncementBar from "@/components/landing/AnnouncementBar";
import Hero from "@/components/landing/Hero";
import MarketMarquee from "@/components/landing/MarketMarquee";
import AmbassadorSection from "@/components/landing/AmbassadorSection";
import MeetFifi from "@/components/landing/MeetFifi";
import FifiQuantAgent from "@/components/landing/FifiQuantAgent";
import { PawfolioSection } from "@/components/landing/PawfolioSection";
import RiskFreeSimulation from "@/components/landing/RiskFreeSimulation";
import AppShowcase from "@/components/landing/AppShowcase";
import MasterInvestors from "@/components/landing/MasterInvestors";
import FifiStore from "@/components/landing/FifiStore";
import TrustStrip from "@/components/landing/TrustStrip";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";

const LandingPage = () => {
  const [ambassadorOpen, setAmbassadorOpen] = useState(false);

  const scrollToHero = () => {
    const el = document.getElementById("hero");
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
    setTimeout(() => {
      document.querySelector('[data-testid="hero-waitlist-input"]')?.focus();
    }, 600);
  };

  const openAmbassador = () => setAmbassadorOpen(true);
  const closeAmbassador = () => setAmbassadorOpen(false);

  return (
    <div id="top" data-testid="landing-page" className="min-h-screen bg-[#FAFAFA]">
      <AnnouncementBar onApplyClick={openAmbassador} />
      <Navbar onWaitlistClick={scrollToHero} onAmbassadorClick={openAmbassador} />
      <main>
        <Hero />
        <MarketMarquee />
        <AmbassadorSection open={ambassadorOpen} onOpen={openAmbassador} onClose={closeAmbassador} />
        <MeetFifi />
        <FifiQuantAgent onNotifyClick={scrollToHero} />
        <PawfolioSection />
        <RiskFreeSimulation />
        <AppShowcase />
        <MasterInvestors />
        <FifiStore />
        <TrustStrip />
        <FAQ />
        <Footer />
      </main>
    </div>
  );
};

export default LandingPage;
